import type { FieldError } from "react-hook-form";
import { useTrads } from "../../contexts/trads/useTrads";
import { getByPath, uniqid } from "../../tools/utils";
import { type fondStatus } from "../../types/Fond";
import type { SelectProps } from "../../types/Interface";

interface PlusStatut {
    statut:fondStatus
};
type StatutSelectProps = SelectProps & PlusStatut

export function FondStatutSelectorBootstrap({name, label, registerOutput, errors, statut}:StatutSelectProps){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name) as FieldError[];
    const {translate}=useTrads()
    return (
        <>
        <div className={ "form-floating " +  (errors[name] ? " is-invalid":'')}>
                <select className={"form-select "+ (errors[name]? " is-invalid":'')} id={id}
                defaultValue={statut}
                 {...registerOutput} 
                >
                    <option value="">-----</option>
                    <option value="00_draft" >{translate('fond_statut_00_draft')}</option>
                    <option value="01_published"  >{translate('fond_statut_01_published')}</option>
                    <option value="02_refused"  >{translate('fond_statut_02_refused')}</option>
                </select>
                <label className="form-label" htmlFor={id}>{label}</label>
                
        </div>
       {field_errors.length > 0 && <div className="invalid-feedback">{field_errors.map((error)=> <p key={error.message}>{translate(error.message)}</p>)}</div>}
 
        </>
    );
}